module.exports = __webpack_public_path__ + "static/img/bandito94.33d2863.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/conversion/testimonial/bandito94.png
// module id = Us8n
// module chunks = 38